import { Badge } from '@/components/ui/badge';
import {
  PropertyKitEntry,
  PropertyKitItem,
  ASSET_STATUS_LABELS,
  CONSUMABLE_STATUS_LABELS,
  isEntryMissing,
} from '@/hooks/inventory';

interface EntryStatusBadgeProps {
  entry: PropertyKitEntry;
  item: PropertyKitItem;
}

export default function EntryStatusBadge({ entry, item }: EntryStatusBadgeProps) {
  const isMissing = isEntryMissing(entry, item);

  switch (item.control_type) {
    case 'fixed_asset': {
      const status = entry.asset_status;
      if (!status) return <Badge variant="outline">-</Badge>;

      const colors = {
        present: 'bg-green-50 text-green-700 border-green-200',
        missing: 'bg-red-50 text-red-700 border-red-200',
        damaged: 'bg-orange-50 text-orange-700 border-orange-200',
      };

      return (
        <Badge variant="outline" className={colors[status]}>
          {ASSET_STATUS_LABELS[status]}
        </Badge>
      );
    }

    case 'consumable': {
      const status = entry.consumable_status;
      if (!status) return <Badge variant="outline">-</Badge>;

      const colors = {
        full: 'bg-green-50 text-green-700 border-green-200',
        half: 'bg-blue-50 text-blue-700 border-blue-200',
        low: 'bg-amber-50 text-amber-700 border-amber-200',
        empty: 'bg-red-50 text-red-700 border-red-200',
      };

      return (
        <Badge variant="outline" className={colors[status]}>
          {CONSUMABLE_STATUS_LABELS[status]}
        </Badge>
      );
    }

    case 'countable': {
      // Use entry's ideal_quantity for status calculation
      const hasIdeal = entry.ideal_quantity != null;
      if (!hasIdeal) {
        return <Badge variant="outline">Sin meta</Badge>;
      }
      if (isMissing) {
        return (
          <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
            Incompleto
          </Badge>
        );
      }
      return (
        <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
          Completo
        </Badge>
      );
    }

    default:
      return null;
  }
}
